import get from "lodash/get";
import {
  LoadersProps,
  NvsLoadersProps,
  NvsLoadersTypes,
  NvsLoadersValue,
} from "./types";
import { PixelationLoader, PixelationLoaderProps } from ".";
import { defaultPixelationLoaderProps } from "../NvsAuthorableScene/constants";

type LoaderJSXElement = (
  props: LoadersProps<PixelationLoaderProps | null>,
) => JSX.Element;

export const LoadersMap = {
  [NvsLoadersTypes.Pixelation]: (props: PixelationLoaderProps) => (
    <PixelationLoader {...props} />
  ),
};

export const LoadersDefaultPropMap = {
  [NvsLoadersTypes.Pixelation]: defaultPixelationLoaderProps,
};

// Setting this up for future loader additions
export const getLoaderComponent = (loaderType: NvsLoadersValue) => {
  return {
    LoaderComponent: get(LoadersMap, loaderType) as LoaderJSXElement | null,
    defaultProps: get(LoadersDefaultPropMap, loaderType),
  };
};
